import AppDataService from "./AppDataService";

const COMMON_BASE = "Payer"

export default class PayerDataService {

    static async savePayer(payerData) {
        return await AppDataService.post(`${COMMON_BASE}/Save`, payerData);
    }

    static async editPayer(payerData) {
        return await AppDataService.put(`${COMMON_BASE}/Edit`, payerData);
    }

    static async uploadSheet(data) {
        return await AppDataService.post(`${COMMON_BASE}/UploadSheet`, data)
    }

    static async getTemplate() {
        return await AppDataService.get(`${COMMON_BASE}/GetTemplate`)
    }

    static async validateSheetRecords() {
        return await AppDataService.get(`${COMMON_BASE}/BulkSave`)
    }

    static async getErrorReport() {
        return await AppDataService.get(`${COMMON_BASE}/GetErrorSheet`)
    }

    static async getPayersList(formDetails = {}) {
        const { formName, year } = formDetails
        const queryParams = formName && year ? `?formName=${formName}&year=${year}` : ""
        return await AppDataService.get(`${COMMON_BASE}/Get${queryParams}`, {
            headers: {
                'Content-Type': 'application/json'
            },
        });
    }

    static async getPaginatedPayersList(params) {
        return await AppDataService.get(`${COMMON_BASE}/GetPayersList`, { params });
    }

    static async getPayer(payerId) {
        return await AppDataService.get(`${COMMON_BASE}/Get/${payerId}`)
    }

    static async getFormsStatus(payerID, taxYear) {
        return await AppDataService.get(`${COMMON_BASE}/GetFormsStatus?PayerId=${payerID}&TaxYear=${taxYear}`)
    }

    static async getRecipientsStatus(payerID) {
        return await AppDataService.get(`${COMMON_BASE}/GetRecipientsStatus?PayerId=${payerID}`)
    }

    static async assignPayers(data) {
        return await AppDataService.post(`${COMMON_BASE}/AssignPayers`, data)
    }

    static async deActivatePayer(data) {
        return await AppDataService.put(`${COMMON_BASE}/DeActivate`, data)
    }

    static async deletePayer(data) {
        return await AppDataService.delete(`${COMMON_BASE}/Delete`, data)
    }

    static async getMemberUsers(params) {
        return await AppDataService.get(`${COMMON_BASE}/GetMemberUsers`, { params })
    }

    static async getHeadersForPayerReport() {
        return await AppDataService.get(`${COMMON_BASE}/GetHeadersForPayerReport`)
    }

    static async downloadPayerReport(data) {
        return await AppDataService.post(`${COMMON_BASE}/DownloadPayerReport`, data)
    }

    static async activatePayer(data) {
        return await AppDataService.put(`${COMMON_BASE}/Activate`, data)
    }

    static async saveIntermediary(data) {
        return await AppDataService.post(`${COMMON_BASE}/SaveIntermediary`, data)
    }

    static async getIntermediaryDetails(id) {
        return await AppDataService.get(`Forms/GetIntermediary?id=${id}`);
    }
    
    static async getMemberList(data) {
        const {PageNumber, PageSize, FilterText, IsDesc} = data;
        return await AppDataService.get(`${COMMON_BASE}/GetMemberUsers?PageNumber=${PageNumber}&PageSize=${PageSize}&FilterText=${FilterText}&IsDesc=${IsDesc}`, {
            headers: {
                'Content-Type': 'application/json'
            },
        })
    }

}